<template>
    <section class="ui-card">
        <header v-if="title || $slots.actions || $slots.header" class="ui-card__header">
            <div>
                <slot name="header">
                    <h3 class="ui-section-title">{{ title }}</h3>
                    <p v-if="description" class="ui-section-description">{{ description }}</p>
                </slot>
            </div>
            <div v-if="$slots.actions" class="ui-card__actions">
                <slot name="actions"></slot>
            </div>
        </header>
        <div :class="flush ? 'ui-card__body--flush' : 'ui-card__body'">
            <slot></slot>
        </div>
        <footer v-if="$slots.footer" class="ui-card__footer">
            <slot name="footer"></slot>
        </footer>
    </section>
</template>

<script>
// Cartao de secao: titulo + descricao + acoes no cabecalho; `flush` encosta
// tabelas nas bordas.
export default {
    name: "UiSection",
    props: {
        title: { type: String, default: null },
        description: { type: String, default: null },
        flush: { type: Boolean, default: false },
    },
};
</script>
